import(/* webpackMode: "eager" */ "/app/component/block/pageWrapper/pageWrapper.tsx");
import(/* webpackMode: "eager" */ "/app/component/page/search/trending-community/trending-community-header.tsx");
import(/* webpackMode: "eager" */ "/app/component/page/search/trending-community/trending-community.tsx")